module.exports = __webpack_public_path__ + "static/media/addIcon.f685c035.svg";